// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__3e0XE","loadingShrink":"PageLoading_loadingShrink__RHAOx"};